export default "__VITE_ASSET__DYDwYbxN__"